export default {
      id: "deco_carte-usage",
      viewBox: "0 0 75 80",
      url: "../dist/images/" + "sprite.svg#deco_carte-usage",
      toString: function () {
        return this.url;
      }
    }